import { Inject, Injectable } from '@angular/core';
import { Device } from '@ionic-native/device';
import { Actions, Effect } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Alert, AlertController } from 'ionic-angular';
import { Observable } from 'rxjs/Observable';
import { STATE_STORAGE_TOKEN } from '../../../app/injection-tokens';
import { IStorage } from '../../../core/services/storage/storage.interface';
import { isPersistableAction } from '../../../core/store/actions/base-actions';
import { StatePersistor } from '../../../core/store/persister/statepersistor';
import * as fromResetActions from '../../../core/store/reset-state/reset.actions';
import { ENVIRONMENTS } from '../../../environments/environments';
import { VasAppFacade } from '../../services/vas-app-facade.service';
import { ENV } from '../../../environments/environment';

@Injectable()
export class CollectionEffects {

    storageFailureAlert: Alert;

    @Effect({dispatch: false})
    reset$: Observable<Action> = this.actions$
        .ofType(fromResetActions.RESET)
        .mergeMap((action: Action) => {
            return Observable.fromPromise(this.resetStorage()).map(
                () => {
                    console.log('STORAGE HAS BEEN RESET');
                    return action;
                }
            );
        });

    /**
     * This side effect is triggered automatically when the app starts. It loads the saved
     * state from local storage and hydrates the store.
     * @type {Observable<Action>}
     */
    // @Effect()
    // hydrate$: Observable<Action> = this.actions$
    //     .ofType(fromRehydrateActions.REHYDRATE)
    //     .startWith(new fromRehydrateActions.RehydrateAction())
    //     .mergeMap((action: Action) => {
    //
    //         const stateHydrator = new StateHydrator(Object.keys(fromRoot.reducers), this.storage);
    //
    //         return Observable.fromPromise(stateHydrator.getState().then(
    //             state => {
    //                 console.log("rehydrating state");
    //                 return new fromRehydrateActions.RehydrateSuccessAction(state);
    //                 // return new fromRehydrateActions.RehydrateSuccessAction(undefined);
    //             },
    //             error => {
    //                 console.error("failed to hydrate state");
    //                 return new fromRehydrateActions.RehydrateFailAction();
    //             }
    //         ));
    //     });

    /**
     * This side effect saves the changed item to local storage
     * @type {Observable<Action>}
     */
    @Effect({dispatch: false})
    persistableActions$: Observable<Action> = this.actions$
        .map(action => {
            this.handleAction(action);
            return action;
        });

    statePersistor: StatePersistor;

    constructor(
        protected appFacade: VasAppFacade,
        protected actions$: Actions,
        @Inject(STATE_STORAGE_TOKEN) protected storage: IStorage,
        protected alertController: AlertController,
        protected device: Device
    ) {

        this.statePersistor = new StatePersistor(this.storage);
    }

    handleAction(action): void {

        if (isPersistableAction(action)) {
            this.statePersistor.persistAction(action).then(
                () => {
                    // noop
                },
                error => {
                    console.error('failed to persist action', error, action);
                    this.storageFailure();
                }
            );
        }
    }

    resetStorage(): Promise<any> {
        return Promise.all([
            this.statePersistor.storage.clear(),
            this.appFacade.changeLog.clear()
        ]);
    }

    storageFailure(): void {

        if (ENV.name === ENVIRONMENTS.E2E) {
            return;
        }

        if (this.storageFailureAlert) {
            return;
        }

        this.storageFailureAlert = this.alertController.create();

        const message = `
        A problem was detected with the storage on your device so the last action has not been saved - yet.
        This could be the result of too many programs/tabs open or low disk space. First try to close some programs/tabs,
        then checking if your system is low on disk space. If the problem persists please contact support.`;

        this.storageFailureAlert.setTitle('Problem with Storage');
        this.storageFailureAlert.setMessage(message);
        this.storageFailureAlert.addButton({
            text: 'Ok',
            role: 'cancel',
            handler: () => {
                this.storageFailureAlert = undefined;
            }
        });

        this.storageFailureAlert.present();
    }
}



// WEBPACK FOOTER //
// ./src/vas/store/effects/collection.ts